import { Box } from '@chakra-ui/react'
import SvgIcon from 'components/SvgIcon'
import { DARK_TEXT_LIGHT } from 'constants/dark-tokens'
import { MOBILE_MANAGE_TAB } from 'constants/mobile-page-template'

interface IMobileManageTabProps {
  isManageMode: boolean
  onToggle: () => void
}

/**
 * The Manage/Done control on a phone: a tab hanging off the right edge of the
 * viewport.
 *
 * On a desktop header the control is a labelled pill beside the breadcrumb. At
 * phone width that row holds a page name and nothing else, so the control leaves
 * the header entirely and becomes an icon-only tab — a pencil while the page is
 * read-only, a tick while it is being edited, mirroring the pill's
 * "Manage" / "Done" wording.
 *
 * Renders on the base breakpoint only; md+ keeps the pill in the header.
 */
const MobileManageTab = ({ isManageMode, onToggle }: IMobileManageTabProps) => (
  <Box
    as="button"
    type="button"
    aria-label={isManageMode ? 'Done' : 'Manage'}
    aria-pressed={isManageMode}
    onClick={onToggle}
    {...MOBILE_MANAGE_TAB}
    display={{ base: 'flex', md: 'none' }}
    cursor="pointer"
    _focus={{ boxShadow: 'none', outline: 'none' }}
    _focusVisible={{ boxShadow: 'none', outline: 'none' }}
    _active={{ opacity: 0.85 }}
    sx={{ WebkitTapHighlightColor: 'transparent' }}
  >
    <SvgIcon
      iconName={isManageMode ? 'ic_baseline-check-circle-outline' : 'ic_baseline-edit'}
      size={20}
      color={DARK_TEXT_LIGHT}
    />
  </Box>
)

export default MobileManageTab
